import React from 'react'
import './index.css';
import Property8 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property8 num="+91-2934572" type="Micro Rustic Room" desc="Come and enjoy the experience of a micro rustic room alone . Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Pre-Book Your room for your partner , family or friends to enjoy the seamless checkin." price = "1000" guests="1" bed="1"  bath="1"/>
    </div>
  )
}

export default Property
